import zh from './zh'
// 中文站使用明确的单一页面语言；完整英文版应拥有独立 URL 后再启用。
export function t(key) {
  return key.split('.').reduce((value,part)=>value && value[part],zh) ?? key
}
export default {install(app){app.config.globalProperties.$t=t}}
